<template>
  <div>
    <el-select 
      :placeholder="$t('Seçin')"  
      size="small"  
      filterable 
      :value="selected" 
      @input="handleInput" 
      style="width: 100%"
      :disabled="readonly"
    >
      <el-option v-for="item in sortedData" :key="item.id" :label="getItemName(item)" :value="item.id">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { usersbyrole } from "../../services/sales";
export default {
  props: {
    value: [Number, String],
    region: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      data: [],
      selected: this.value,
      bakiItems: [],
    };
  },
  methods: {
    handleInput(e) {
      this.$emit("input", e);
      this.$emit("comm", this.data.find(item => item.id === e).name);
      this.selected = e;
    },
    getData() {
      usersbyrole(4).then((response) => {
        if (response.data) {
          this.data = response.data;
        } else {
          this.$message({
            type: "error",
            message: "Accident commissar users: No data found!",
          });
        }
      });
    },
    getItemName(item) {
      if(this.region) {
        switch(item.id) {
          case 63:
          case 64:
          case 66: 
          case 601:
          case 602:
          case 62: return item.name + " - Bakı";
          case 59: return item.name + " - Sabirabad";
          case 71: return item.name + " - Gəncə";
          case 72: return item.name + " - Qobustan";
          case 67: return item.name + " - Şəki";
          case 69: return item.name + " - Beylegan";
          case 641: return item.name + " - Sumqayıt";
          case 642: return item.name + " - Şabran";
          case 643: return item.name + " - Lənkəran";
          
          default: return item.name;
        }
      } else {
        return item.name;
      }
    },
  },
  mounted() {
    this.getData();
  },
  computed: {
    sortedData() {
      return [...this.data].sort((a, b) => {
        const aName = this.getItemName(a);
        const bName = this.getItemName(b);

        if (aName.includes(' - Bakı') && !bName.includes(' - Bakı')) {
          return -1;
        }
        if (!aName.includes(' - Bakı') && bName.includes(' - Bakı')) {
          return 1;
        }
        return 0;
      });
    },
  },
  watch: {
    value() {
      this.selected = this.value;
    },
  },
};
</script>

<style lang="scss" scoped></style>